import { hexToBinary, toUserIdRaw } from '@streamr/utils';
import { StreamrTvViewer } from '../../engine/StreamrTvViewer';
import { PurchaseService } from '../purchase/PurchaseService';
import { VideoPropertiesService } from '../videoProperties/VideoPropertiesService';
import { ViewerCountService } from '../viewercount/ViewerCountService';
import { ViewerServiceOutput } from './ViewerServiceOutput';
export class ViewerService {
    static instance;
    static getInstance() {
        if (!ViewerService.instance) {
            ViewerService.instance = new ViewerService();
        }
        return ViewerService.instance;
    }
    static getNotificationInterface() {
        return ViewerService.getInstance();
    }
    static getOutput() {
        return ViewerServiceOutput.getReactiveOutput();
    }
    // --- Singleton end
    viewer;
    output;
    streamingTimeoutId;
    currentStreamId;
    currentCanvas;
    constructor() {
        this.output = new ViewerServiceOutput();
    }
    async init() {
        // No initialization needed
    }
    // Notifications
    notifyMuteToggle() {
        const currentMuted = this.output.getAudioMuted();
        const isMuted = currentMuted === undefined ? true : currentMuted;
        const willUnmute = isMuted;
        if (this.viewer) {
            if (willUnmute) {
                this.viewer.unmuteAudio();
            }
            else {
                this.viewer.muteAudio();
            }
        }
        this.output.setAudioMuted(!willUnmute);
    }
    onFrameReceived() {
        if (!this.output.getWatchingStartedAt()) {
            this.output.setWatchingStartedAt(new Date());
        }
        this.output.setIsVideoStreaming(true);
        this.output.setLastReceivedFrameAt(Date.now());
        if (this.streamingTimeoutId !== undefined) {
            window.clearTimeout(this.streamingTimeoutId);
        }
        this.streamingTimeoutId = window.setTimeout(() => {
            this.output.setIsVideoStreaming(false);
            this.streamingTimeoutId = undefined;
        }, 5000);
    }
    createViewer(activeBroadcast) {
        const viewer = new StreamrTvViewer({
            streamId: activeBroadcast.streamId,
            broadcasterUserId: toUserIdRaw(activeBroadcast.broadcasterUserId),
            aesKey: hexToBinary(activeBroadcast.aesKey),
        });
        viewer.on('muteChange', (muted) => {
            this.output.setAudioMuted(muted);
        });
        viewer.on('receivedFrame', () => {
            this.onFrameReceived();
        });
        viewer.on('broadcastMetadataChanged', (broadcastMetadata) => {
            if (this.currentStreamId) {
                ViewerCountService.getInstance().notifyViewerCountChangedForActiveStream(broadcastMetadata.viewerCount);
                PurchaseService.getInstance().notifyProductsOfActiveBroadcastChanged(broadcastMetadata.products, false);
            }
        });
        viewer.on('videoPropertiesChanged', (videoProperties) => {
            VideoPropertiesService.getNotificationInterface().notifyVideoPropertiesChanged(videoProperties);
        });
        return viewer;
    }
    notifyActivateBroadcast(activeBroadcast, canvas) {
        if (this.currentStreamId === activeBroadcast.streamId &&
            this.currentCanvas === canvas &&
            this.viewer) {
            return;
        }
        this.currentStreamId = activeBroadcast.streamId;
        this.currentCanvas = canvas;
        // Stop previous viewer if any
        this.viewer?.stop().catch(() => undefined);
        this.viewer = this.createViewer(activeBroadcast);
        this.viewer
            .start(canvas)
            .then(() => {
            this.output.setViewer(this.viewer);
            this.output.setReady(true);
        })
            .catch((error) => {
            console.error(error);
        });
    }
    notifyDeactivateBroadcast() {
        this.currentCanvas = undefined;
        this.output.setViewer(undefined);
        this.viewer?.stop().catch(() => undefined);
        this.viewer = undefined;
    }
}
